import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Collapse } from '@mui/material'
import React, { useEffect } from 'react'
import { useWatch } from 'react-hook-form'
import { SettingsBox } from 'src/Elements/Data'
import { useUser } from 'src/Hooks/useUser'
import { useInstallationForm } from 'src/Libs/flow/installation/hooks'
import { TabButtonGroup, Toggle } from 'src/Libs/inputs/react-hook-form'
import { useInstallationAccessRightsContext } from 'src/Libs/installation-rights-management/provider/InstallationAccessRightsContext'

export const ChargingPriority: React.FC = () => {
  const { t } = useCustomTranslation()
  const { hasInstallationWritingRights: canEdit } = useInstallationAccessRightsContext()
  const { userData } = useUser()

  const { control, setValue } = useInstallationForm()
  const priorityChargingDevice = useWatch({
    control,
    name: 'storageSystem.generalSettings.chargingConfiguration.priorityChargingDevice',
  })

  const isChargingStation = priorityChargingDevice === 'charging station'
  const isToggleDisabled = !isChargingStation || !canEdit
  const isUserLevelUser = userData?.level === 'USER'

  useEffect(() => {
    if (!isChargingStation) {
      setValue('storageSystem.generalSettings.chargingConfiguration.useBatteryDischargeOnlyWhenPvIsExceeded', false, {
        shouldDirty: true,
      })
      setValue('storageSystem.generalSettings.chargingConfiguration.useBatteryDischargeOnlyInOtherMode', false, {
        shouldDirty: true,
      })
    }
  }, [isChargingStation, setValue])

  return (
    <Box>
      <SettingsBox
        title={t(`installation.storageEditor.chargingPriority`)}
        suffix={
          <TabButtonGroup
            name="storageSystem.generalSettings.chargingConfiguration.priorityChargingDevice"
            options={[
              {
                label: t('installation.storageEditor.priorityEvse'),
                value: 'charging station',
              },
              {
                label: t('installation.storageEditor.priorityBattery'),
                value: 'battery',
              },
            ]}
            disabled={!canEdit || isUserLevelUser}
          />
        }
      >
        <Collapse in={isChargingStation}>
          <SettingsBox
            title={t('installation.storageEditor.batteryDischargeEvse')}
            suffix={
              <Toggle
                name="storageSystem.generalSettings.chargingConfiguration.useBatteryDischargeOnlyWhenPvIsExceeded"
                disabled={isToggleDisabled || isUserLevelUser}
              />
            }
            isSingleLine
            depth={1}
          />

          <SettingsBox
            title={t('installation.storageEditor.batteryDischargeStrategy')}
            suffix={
              <Toggle
                name="storageSystem.generalSettings.chargingConfiguration.useBatteryDischargeOnlyInOtherMode"
                disabled={isToggleDisabled || isUserLevelUser}
              />
            }
            isSingleLine
            depth={1}
          />
        </Collapse>
      </SettingsBox>
    </Box>
  )
}
